import { Reducer } from 'redux';

import {
    FetchActions, FetchState
} from './fetch-middleware.types';
import {
    isFetchClearAction, isFetchFailureAction, isFetchLoadAction, isFetchSuccessAction
} from './utils';

export const INITIAL_FETCH_STATE: FetchState = {
    data: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    error: null
};

export function createFetchReducer<TData> (
    name: string,
    initialState: FetchState<TData> = INITIAL_FETCH_STATE
): Reducer<FetchState<TData>> {
    return (
        state: FetchState<TData> = initialState,
        action: Partial<FetchActions>
    ): FetchState<TData> => {
        if (isFetchLoadAction(name, action)) {
            return {
                ...state,
                ...INITIAL_FETCH_STATE,
                isLoading: true
            };
        } else if (isFetchSuccessAction(name, action)) {
            return {
                ...state,
                isLoading: false,
                isSuccess: true,
                data: action?.payload?.data || null as any
            };
        } else if (isFetchFailureAction(name, action)) {
            return {
                ...state,
                isLoading: false,
                isError: true,
                isSuccess: false,
                error: action.payload.error
            };
        } else if (isFetchClearAction(name, action)) {
            return {
                ...initialState,
                ...INITIAL_FETCH_STATE
            };
        } else {
            return state;
        }
    };
}

